import React from 'react';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';

import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import usePermission from 'routes/usePermission';

import { URL, LABEL, FINANCE_RESOURCES, GET_ACTION, IMAGE_SOURCE } from './helper';

const useFinanceHome = () => {
	const { hasPermission } = usePermission();

	const isEnabled = (subEntity: string) => {
		return hasPermission({
			configPageName: PAGE_NAMES.dashboard,
			entity: DASHBOARD_RESOURCES.finance,
			action: GET_ACTION[subEntity]
		});
	};

	return { isEnabled };
};

const FinanceHome: React.FC<{}> = () => {
	const history = useHistory();
	const { isEnabled } = useFinanceHome();
	const [css] = useStyletron();

	const keyHeading = css({
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-evenly',
		alignItems: 'center',
		height: '50%'
	});

	const subKeyHeading = css({
		height: '130px',
		width: '40%',
		cursor: 'pointer'
	});

	const cardCSS = {
		width: '100%',
		height: '100%'
	};

	return (
		<div className={keyHeading}>
			{_map(_keys(FINANCE_RESOURCES), (subEntity: string) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={subKeyHeading}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => cardCSS
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default FinanceHome;
